/*! XCS Inkooptool wizard — uses xcs-inkoopschatting.js (Occasions engine) */
(function () {
  'use strict';

  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function fmtEur(n) {
    try {
      return new Intl.NumberFormat(((document.documentElement.lang || 'nl').slice(0, 2)) + '-BE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(n);
    } catch (e) {
      return '€ ' + Math.round(n).toLocaleString('nl-BE');
    }
  }

  // Photos are not uploaded: the customer sends them after submitting (WhatsApp or mail) with a reference.
  // The customer answers two questions in step 3 (photos_ok, docs_ok: yes / no / unknown), 20/10/2026.
  // yes -> engine photos 4 (no x0.97) resp. vin + registration provided (no x0.98); no or unknown -> photos 0 (x0.97) resp. missing (x0.98).
  var ANSWER_NL = { yes: 'Ja', no: 'Nee', unknown: 'Weet ik niet' };

  function makeRef() {
    var d = new Date();
    var yymmdd = String(d.getFullYear()).slice(2) + ('0' + (d.getMonth() + 1)).slice(-2) + ('0' + d.getDate()).slice(-2);
    var abc = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    var out = '';
    var rnd = new Uint8Array(4);
    if (window.crypto && window.crypto.getRandomValues) window.crypto.getRandomValues(rnd);
    else for (var i = 0; i < 4; i++) rnd[i] = Math.floor(Math.random() * 256);
    for (var j = 0; j < 4; j++) out += abc.charAt(rnd[j] % abc.length);
    return 'XCS-' + yymmdd + '-' + out;
  }

  function fill(tpl, vars) {
    return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) { return vars[k] != null && vars[k] !== '' ? String(vars[k]) : ''; });
  }


  // XCS 21/10: sportieve uitvoeringen krijgen geen automatisch bedrag maar een persoonlijk bod.
  // De prijstabel bevat enkel reguliere versies (een Golf GTI werd als gewone Golf berekend).
  // Twee signalen: (1) versie/model-tekst, (2) vermogen. Pakketten zoals R-Line, S line, M Sport,
  // AMG Line, GT Line, ST-Line, RS Line, N Line, Sportline en GR Sport tellen niet als sportversie.
  var SPORT_EXCL = /\b(r line|s line|m sport(?: ?(?:pakket|paket|package|pack|edition|plus))?|m pakket|m pack(?:age)?|m paket|amg line|amg pakket|amg paket|amg package|amg styling|amg design|gt line|st line|rs line|n line|sport ?line|gr sport|gt sport|r design|r dynamic|s design|cupra look|fr line)\b/g;
  function normMake(mk) {
    mk = (mk || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    if (mk === 'vw' || mk === 'volkswagen') return 'volkswagen';
    if (/^mercedes/.test(mk) || mk === 'mb') return 'mercedes';
    return mk;
  }
  function sportText(make, model, version) {
    var mk = normMake(make);
    var txt = (' ' + [make, model, version].join(' ') + ' ').toLowerCase()
      .replace(/r\.s\./g, 'rs').replace(/[_\-\/.,()+]+/g, ' ').replace(/\s+/g, ' ');
    txt = txt.replace(SPORT_EXCL, ' ').replace(/\s+/g, ' ');
    // samengestelde schrijfwijzen samenvoegen: "RS 3" -> rs3, "A 45" -> a45, "X5 M" -> x5m, "Type R" -> typer
    txt = txt.replace(/\brs (q?\d|e tron)\b/g, function (m, a) { return 'rs' + a.replace(' ', ''); })
      .replace(/\bs (q?\d)\b/g, 's$1')
      .replace(/\b(x[1-7]|z4) m\b/g, '$1m')
      .replace(/\btype r\b/g, 'typer')
      .replace(/\bgr (yaris|supra|86|corolla)\b/g, 'gr$1');
    if (mk === 'mercedes' || /\bmercedes\b/.test(txt)) txt = txt.replace(/\b(cla|cls|gla|glb|glc|gle|gls|slc|sl|ml|gl|gt|a|c|e|s|g) (35|43|45|53|55|63|65)\b/g, '$1$2');
    var rules = [
      ['Cupra', function () { return mk === 'cupra' || /\bcupra\b/.test(txt); }],
      ['GTI', /\bgti\b/], ['GTD', /\bgtd\b/], ['Clubsport', /\bclubsport\b/], ['TCR', /\btcr\b/],
      ['AMG', /\bamg\b/],
      ['AMG', mk === 'mercedes' ? /\b(cla|cls|gla|glb|glc|gle|gls|slc|sl|ml|gl|gt|a|c|e|s|g)(35|43|45|53|55|63|65)\b/ : null],
      ['R', mk === 'volkswagen' ? /\b(r|r32|r36|r20)\b/ : null],
      ['Audi S/RS', (mk === 'audi' || /\baudi\b/.test(txt)) ? /\b(s[1-8]|sq[2-8]|rs ?q?\d|rs e tron(?: gt)?|tts|tt rs|r8)\b/ : null],
      ['BMW M', (mk === 'bmw' || /\bbmw\b/.test(txt)) ? /\b(m[2-8]|1m|x[3-7]m|z4m|m\d{2,3}[id]|m performance|m competition)\b/ : null],
      ['RS', (mk === 'skoda' || mk === 'ford' || mk === 'renault') ? /\brs\b/ : null],
      ['vRS', /\bvrs\b/],
      ['Abarth', function () { return mk === 'abarth' || /\babarth\b/.test(txt); }],
      ['ST', mk === 'ford' ? /\bst\b/ : null],
      ['N', mk === 'hyundai' ? /\b(i20|i30|kona|elantra|ioniq ?5)? ?n\b/ : null],
      ['Type R', /\btyper\b/],
      ['GR', mk === 'toyota' ? /\b(gr|gryaris|grsupra|gr86|grcorolla|gt86)\b/ : null]
    ];
    for (var i = 0; i < rules.length; i++) {
      var r = rules[i][1];
      if (!r) continue;
      if (typeof r === 'function' ? r() : r.test(txt)) return rules[i][0];
    }
    return null;
  }
  // Vermogen (XCS 22/10): enkel voor benzine en diesel, nooit voor (plug-in) hybride of elektrisch.
  // De prijstabel geeft per model/brandstof enkel klassegrenzen (cutsHp = ondergrens van de hogere
  // klassen), geen bovengrens. Daarom: drempel = max(201, 1,35 x hoogste grens, hoogste reguliere
  // vermogen + 1). REG_TOP_HP = hoogste vermogen van een gewone (niet-sport) motor van dat model,
  // enkel ingevuld waar dat boven 1,35 x de hoogste grens ligt (6-cilinders, 2.0 BiTDI, ...).
  // Geen vermogensdata voor model/brandstof = geen vermogensregel (enkel tekstherkenning).
  // Brandstof onbekend: benzineregel als het model benzinedata heeft, anders geen vermogensregel.
  // Porsche en Tesla worden nooit op vermogen alleen uitgesloten: die rekent de tabel zelf.
  var REG_TOP_HP = {
    'volkswagen|passat|diesel': 240,
    'audi|a4|diesel': 286, 'audi|a6|diesel': 349, 'audi|a6|petrol': 340, 'audi|q5|diesel': 286,
    'bmw|2-reeks|petrol': 252, 'bmw|2-reeks|diesel': 231, 'bmw|3-reeks|petrol': 258, 'bmw|3-reeks|diesel': 313,
    'bmw|5-reeks|petrol': 340, 'bmw|5-reeks|diesel': 340, 'bmw|x1|diesel': 231, 'bmw|x2|diesel': 231,
    'bmw|x3|diesel': 286,
    'mercedes|c-klasse|petrol': 333, 'mercedes|c-klasse|diesel': 272, 'mercedes|e-klasse|petrol': 367,
    'mercedes|e-klasse|diesel': 340, 'mercedes|glc|diesel': 330, 'mercedes|gla|petrol': 224,
    'renault|megane|petrol': 205, 'volvo|xc40|petrol': 252
  };
  var FUEL_NORM = { petrol: 'petrol', benzine: 'petrol', essence: 'petrol', diesel: 'diesel',
    hybrid: 'hybrid', hybride: 'hybrid', phev: 'hybrid', electric: 'electric', elektrisch: 'electric', ev: 'electric' };
  function powerTop(table, mk, md, fuel) {
    var found = null;
    (table.models || []).forEach(function (m) {
      if (normMake(m.make) !== mk || String(m.model || '').trim().toLowerCase() !== md || m.fuel !== fuel) return;
      var p = m.xcs && m.xcs.power;
      if (p && p.cutsHp && p.cutsHp.length) found = Math.max(found || 0, p.cutsHp[p.cutsHp.length - 1]);
    });
    return found;
  }
  // XCS 22/10: (plug-in) hybride/elektrisch herkennen uit merk/model/versie, enkel gebruikt als de brandstof onbekend is.
  // Bv. C 300 e, 300e, 330e, 225xe, 740Le, E 300 de, xDrive30e, 40 TFSI e, 1.4 TSI e, E-Tech, GTE, eHybrid, e-Hybrid, PHEV, hybrid(e), e-tron,
  // EV, ID.3/ID.4/ID. Buzz, EQA..EQS, e-Golf, e-208, Ioniq, electric/elektrisch/electrique, Recharge, T8, 4xe, plug-in.
  function electrifiedText(make, model, version) {
    var t = (' ' + [make, model, version].join(' ') + ' ').toLowerCase()
      .replace(/[\u00e9\u00e8]/g, 'e').replace(/[_\/,;()+]/g, ' ').replace(/\s+/g, ' ');
    return /(^|[^\d.])\d{2,3} ?(x|l|d)?e\b/.test(t) ||
      /\b(gte|phev|hev|e:hev|plug ?-?in|hybrid\w*|hybride\w*|ehybrid|e-?tron|ev|bev|electric|elektrisch\w*|electrique\w*|recharge|twin engine|4xe|t8|e-?power|ioniq\w*)\b/.test(t) ||
      /\be-(hybrid|golf|up|208|2008|308|3008|c4|niro|soul|corsa|mokka|crafter|transit|tron|power|ace|tense|tech)\b/.test(t) ||
      /\b(t?fsi|tsi) ?e\b/.test(t) ||
      /\bid\. ?\w+/.test(t) || /\bid ?[3-7]\b/.test(t) ||
      /\beq[abcesv]\b/.test(t) || (/\bskoda\b/.test(t) && /\b(iv|enyaq)\b/.test(t));
  }
  function sportPowerLimit(table, data) {
    var mk = normMake(data.make), md = (data.model || '').trim().toLowerCase();
    if (mk === 'porsche' || mk === 'tesla') return null;
    var raw = String(data.fuel || '').trim().toLowerCase();
    var fuel = raw && raw !== 'unknown' ? (FUEL_NORM[raw] || 'other') : null;
    if (fuel === null) {
      // XCS 22/10: onbekend + model/versie wijst op (plug-in) hybride of elektrisch = geen vermogensregel.
      if (electrifiedText(data.make, data.model, data.version)) return null;
      fuel = 'petrol'; // onbekend: benzineregel, enkel als er benzinedata is (zie hieronder)
    }
    if (fuel !== 'petrol' && fuel !== 'diesel') return null;
    var top = powerTop(table, mk, md, fuel);
    if (top == null) return null;
    var reg = REG_TOP_HP[mk + '|' + md + '|' + fuel] || 0;
    return Math.max(201, Math.round(top * 1.35), reg ? reg + 1 : 0);
  }
  function detectSport(table, data) {
    var hit = sportText(data.make, data.model, data.version);
    if (hit) return { by: 'versie', match: hit };
    if (data.power_hp != null && isFinite(data.power_hp)) {
      var lim = sportPowerLimit(table, data);
      if (lim != null && data.power_hp >= lim) return { by: 'vermogen', match: data.power_hp + ' pk', limit: lim };
    }
    return null;
  }
  // XCS 22/10: harde uitsluitingen (ouder dan 12 jaar, > 200.000 km, schade, waarde > 80.000 euro)
  // gaan voor op de sportcontrole, zodat de juiste reden in de aanvraag staat. Uitkomst blijft persoonlijk bod.
  var EXCL_REASON = /^(age_over_|km_over_|value_over_|exterior:|accident:|warning_lights:)/;
  function preExclusion(table, data, res, refDate) {
    if (res && res.status === 'no_match' && EXCL_REASON.test(res.reason || '')) return res;
    var th = table.thresholds || {}, msg = (table.messages && table.messages.no_match) || '';
    var nm = function (r) { return { status: 'no_match', reason: r, message: msg, steps: [], flags: [] }; };
    var adj = table.adjustments || {};
    var keys = ['exterior', 'accident', 'warning_lights'];
    for (var i = 0; i < keys.length; i++) {
      var v = String(data[keys[i]] || 'unknown').trim().toLowerCase(), map = adj[keys[i]] || {};
      if (Object.prototype.hasOwnProperty.call(map, v) && map[v] === null) return nm(keys[i] + ':' + v);
    }
    var year = parseInt(data.year, 10), month = parseInt(data.month, 10);
    if (!(month >= 1 && month <= 12)) month = (table.unknown_defaults && table.unknown_defaults.month) || 1;
    if (isFinite(year) && th.max_age_years != null) {
      var ref = refDate || new Date();
      var age = ref.getFullYear() + (ref.getMonth() + (ref.getDate() - 1) / 31) / 12 - (year + (month - 0.5) / 12);
      if (age > th.max_age_years) return nm('age_over_' + th.max_age_years);
    }
    var km = Number(data.km);
    if (data.km != null && data.km !== '' && isFinite(km) && th.max_km != null && km > th.max_km) return nm('km_over_' + th.max_km);
    return null;
  }
  function estimateWithSport(eng, table, data, refDate) {
    var res = eng(table, data, { refDate: refDate || new Date() });
    var sp = detectSport(table, data);
    if (!sp) return res;
    var ex = preExclusion(table, data, res, refDate);
    if (ex) { ex.sportInfo = sp; return ex; }
    return { status: 'sport', reason: 'sport_version', sport: sp };
  }

  function init(root) {
    if (!root || root.getAttribute('data-xcs-inkoop-ready')) return;
    root.setAttribute('data-xcs-inkoop-ready', '1');

    var cfgEl = document.getElementById('xcs-inkoop-prijstabel') || qs(root, '#xcs-inkoop-prijstabel');
    var i18nEl = document.getElementById('xcs-inkoop-i18n') || qs(root, '#xcs-inkoop-i18n');
    var table = {};
    var i18n = {};
    try { table = JSON.parse(cfgEl ? cfgEl.textContent : '{}') || {}; } catch (e) { table = {}; }
    try { i18n = JSON.parse(i18nEl ? i18nEl.textContent : '{}') || {}; } catch (e) { i18n = {}; }
    // Liquid 't' HTML-escapes strings (e.g. ' -> &#39;): decode once so digit replacements stay safe
    (function () {
      var ta = document.createElement('textarea');
      Object.keys(i18n).forEach(function (k) {
        if (typeof i18n[k] === 'string' && i18n[k].indexOf('&') !== -1) { ta.innerHTML = i18n[k]; i18n[k] = ta.value; }
      });
    })();
    function esc(v) { return String(v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

    function getEngine() { return (typeof window !== 'undefined' && window.inkoopschatting) || null; }
    var engine = getEngine();
    var steps = qsa(root, '[data-step]');
    var bar = qs(root, '[data-progress-bar]');
    var label = qs(root, '[data-progress-label]');
    var form = qs(root, 'form');
    var state = { step: 1, estimate: null, ref: null };
    var totalSteps = 4;

    function t(key, fallback) {
      return i18n[key] != null ? i18n[key] : (fallback != null ? fallback : key);
    }

    // XCS 21/10: scroll enkel bij stapwissel door de gebruiker, rekening houdend met de echte sticky header
    function headerOffset() {
      var h = document.querySelector('.shopify-section-header-sticky, [data-sticky-header], .section-header');
      if (!h) return 0;
      var cs = getComputedStyle(h);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') {
        var inner = h.querySelector('sticky-header, header');
        if (!inner) return 0;
        var ci = getComputedStyle(inner);
        if (ci.position !== 'sticky' && ci.position !== 'fixed') return 0;
        h = inner;
      }
      var r = h.getBoundingClientRect();
      return r.bottom > 0 ? Math.round(r.bottom) : Math.round(h.offsetHeight);
    }
    function scrollToTool() {
      var off = headerOffset();
      var top = root.getBoundingClientRect().top;
      if (top >= off && top < window.innerHeight * 0.35) return;
      var y = top + window.pageYOffset - off - 16;
      try { window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' }); } catch (e) { window.scrollTo(0, Math.max(0, y)); }
    }

    function showStep(n, noScroll) {
      state.step = n;
      steps.forEach(function (el) {
        var sn = Number(el.getAttribute('data-step'));
        el.hidden = sn !== n;
      });
      if (bar) bar.style.width = (((n - 1) / (totalSteps - 1)) * 100) + '%';
      if (label) label.textContent = t('progress', 'Stap') + ' ' + n + ' / ' + totalSteps;
      qsa(root, '[data-step-pill]').forEach(function (p) {
        p.classList.toggle('is-on', Number(p.getAttribute('data-step-pill')) <= n);
      });
      updateNav();
      if (!noScroll) scrollToTool();
    }

    function g(name) {
      var el = form.elements.namedItem(name);
      if (!el) return '';
      if (el.length && el[0] && el[0].type === 'radio') {
        for (var i = 0; i < el.length; i++) if (el[i].checked) return el[i].value;
        return '';
      }
      return el.value;
    }

    function collectEngineInput() {
      var keysRaw = g('keys');
      var keys;
      if (keysRaw === '' || keysRaw === 'unknown') keys = null;
      else if (keysRaw === '3plus') keys = 3;
      else keys = Number(keysRaw);

      var photosOk = g('photos_ok') || 'unknown';
      var docsOk = g('docs_ok') || 'unknown';
      var exteriorPhotos = photosOk === 'yes' ? 4 : 0;
      var hasVin = docsOk === 'yes';
      var powerPk = parseFloat(g('power_pk'));
      var powerKw = parseFloat(g('power_kw'));
      var powerHp = !isNaN(powerPk) ? powerPk : (!isNaN(powerKw) ? Math.round(powerKw * 1.35962) : null);

      var gb = g('gearbox');
      if (gb === 'auto') gb = 'automatic';

      var fuelRaw = g('fuel');
      if (!fuelRaw || fuelRaw === 'unknown') fuelRaw = null;
      if (!gb || gb === 'unknown') gb = null;
      var monthRaw = g('month');
      var monthNum = (monthRaw === 'unknown' || monthRaw === '') ? null : parseInt(monthRaw, 10);

      return {
        make: g('make'),
        model: g('model'),
        fuel: fuelRaw,
        year: parseInt(g('year'), 10),
        month: monthNum,
        km: Number(g('km')),
        gearbox: gb,
        power_hp: powerHp,
        exterior: g('exterior') || 'unknown',
        interior: g('interior') || 'unknown',
        accident: g('accident') || 'unknown',
        warning_lights: g('warning_lights') || 'unknown',
        service_book: g('service_book') || 'unknown',
        inspection: g('inspection') || 'unknown',
        keys: keys,
        extra_tires: g('extra_tires') || 'unknown',
        vat_car: g('vat_car') || 'unknown',
        financing: g('financing') || 'unknown',
        colour: g('color') || '',
        vin_provided: hasVin,
        registration_doc_provided: hasVin,
        photos: exteriorPhotos,
        photos_ok: photosOk,
        docs_ok: docsOk,
        version: g('version') || '',
        price_wanted: g('price_wanted'),
        name: g('contact[name]') || g('name'),
        email: g('contact[email]') || g('email'),
        phone: g('contact[phone]') || g('phone'),
        postcode: g('postcode'),
        channel: g('channel') || 'verkoop'
      };
    }

    function runEstimate(data) {
      var eng = getEngine() || engine;
      if (!eng || !table || !table.models) {
        return { status: 'no_match', reason: 'no_engine', message: t('personal', 'Persoonlijk bod binnen 24u') };
      }
      var est = estimateWithSport(eng, table, data, new Date());
      if (est.status === 'sport') est.message = t('sport_title', 'Persoonlijk bod binnen 24 uur');
      return est;
    }

    function validateStep(n) {
      var panel = qs(root, '[data-step="' + n + '"]');
      if (!panel) return true;
      var required = qsa(panel, '[required]');
      for (var i = 0; i < required.length; i++) {
        var el = required[i];
        if (el.type === 'radio') {
          var group = form.elements.namedItem(el.name);
          var ok = false;
          if (group && group.length) {
            for (var j = 0; j < group.length; j++) if (group[j].checked) ok = true;
          } else if (group && group.checked) ok = true;
          if (!ok) { (group && group[0] ? group[0] : el).focus(); return false; }
        } else if (el.type === 'checkbox') {
          if (!el.checked) { el.focus(); return false; }
        } else if (!el.value) {
          el.focus();
          if (el.reportValidity) el.reportValidity();
          return false;
        }
      }
      return true;
    }

    function renderResult(est) {
      var box = qs(root, '[data-result]');
      var demoBadge = qs(root, '[data-demo-badge]');
      if (demoBadge) demoBadge.hidden = !(table && table.demo);
      if (!box) return;
      var days = (table.thresholds && table.thresholds.offer_valid_days) || 7;
      var hours = (table.thresholds && table.thresholds.contact_within_hours) || 24;
      if (est && est.status === 'ok') {
        box.innerHTML =
          '<p class="xit-price">' + fmtEur(est.range[0]) + ' – ' + fmtEur(est.range[1]) + '</p>' +
          '<p class="xit-note">' + esc(t('indicative', 'Indicatief bod, onder voorbehoud van inspectie ter plaatse, geldig 7 dagen').replace(/\d+/, String(days))) + '</p>' +
          '<p class="xit-note">' + esc(t('contact_24', 'Wij contacteren u binnen 24u met een definitief bod').replace(/\d+/, String(hours))) + '</p>';
      } else if (est && est.status === 'sport') {
        box.innerHTML =
          '<p class="xit-sport__k">' + esc(t('sport_kicker', 'Sportieve uitvoering')) + '</p>' +
          '<p class="xit-price xit-price--soft">' + esc(t('sport_title', 'Persoonlijk bod binnen 24 uur')) + '</p>' +
          '<p class="xit-note">' + esc(t('sport_text', 'Voor deze sportieve uitvoering maken we een persoonlijk bod binnen 24 uur.')) + '</p>' +
          '<p class="xit-note">' + esc(t('sport_help', 'Sportieve versies hebben een eigen marktwaarde. We bekijken uw gegevens en foto\'s en bezorgen u een voorstel op maat.')) + '</p>';
      } else {
        var msg = esc(t('personal', 'Persoonlijk bod binnen 24u'));
        box.innerHTML =
          '<p class="xit-price xit-price--soft">' + msg + '</p>' +
          '<p class="xit-note">' + esc(t('personal_help', 'Voor deze wagen maken wij een voorstel op maat na beoordeling van de gegevens en foto\'s.')) + '</p>';
      }
    }

    function buildBody(data, est) {
      var lines = [
        'INKOOPAANVRAAG XCS' + (est && est.status === 'sport' ? ' (SPORTVERSIE: PERSOONLIJK BOD)' : ''),
        'Referentie: ' + (state.ref || ''),
        'Kanaal: ' + (data.channel || 'verkoop'),
        '',
        'WAGEN',
        'Merk: ' + data.make,
        'Model: ' + data.model,
        'Versie: ' + data.version,
        'Bouwjaar: ' + data.year,
        'Maand: ' + data.month,
        'Brandstof: ' + data.fuel,
        'Versnellingsbak: ' + data.gearbox,
        'Vermogen pk: ' + data.power_hp,
        'Km: ' + data.km,
        'Kleur: ' + data.colour,
        '',
        'STAAT',
        'Exterieur: ' + data.exterior,
        'Interieur: ' + data.interior,
        'Ongeval: ' + data.accident,
        'Waarschuwingslampjes: ' + data.warning_lights,
        'Onderhoudsboekje: ' + data.service_book,
        'Keuring: ' + data.inspection,
        'Sleutels: ' + data.keys,
        'Tweede set banden: ' + data.extra_tires,
        'Financiering/lease: ' + data.financing,
        'Particulier/BTW: ' + data.vat_car,
        '',
        "FOTO'S EN DOCUMENTEN (antwoord klant, te controleren)",
        "Minstens 4 foto's bezorgen: " + (ANSWER_NL[data.photos_ok] || data.photos_ok),
        'Boorddocumenten (inschrijvingsbewijs en gelijkvormigheidsattest): ' + (ANSWER_NL[data.docs_ok] || data.docs_ok),
        '',
        'CONTACT',
        'Naam: ' + data.name,
        'E-mail: ' + data.email,
        'Gsm: ' + data.phone,
        'Postcode: ' + data.postcode,
        'Gewenste prijs: ' + data.price_wanted,
        '',
        'SCHATTING'
      ];
      if (est && est.status === 'ok') {
        lines.push('Vork: ' + est.range[0] + ' - ' + est.range[1] + ' EUR');
        lines.push('Retail P25: ' + est.retailEstimate + ' EUR');
        lines.push('Basisbod: ' + est.baseOffer + ' EUR');
        lines.push('ModelId: ' + est.modelId + ' fuel: ' + est.fuelUsed);
        if (est.flags && est.flags.length) lines.push('Flags: ' + est.flags.join(', '));
      } else if (est && est.status === 'sport') {
        lines.push('Sportversie: persoonlijk bod (herkend via ' + est.sport.by + ': ' + est.sport.match + ')');
        lines.push('Persoonlijk bod (sport_version)');
      } else {
        lines.push('Persoonlijk bod (' + ((est && est.reason) || 'no_match') + ')');
        if (est && est.sportInfo) lines.push('Opmerking: ook sportversie herkend (' + est.sportInfo.by + ': ' + est.sportInfo.match + ')');
      }
      lines.push('');
      lines.push("FOTO'S: klant stuurt na verzending minstens 4 buitenfoto's en kentekenbewijs of VIN via WhatsApp of mail, met referentie " + (state.ref || '') + '.');
      lines.push('Taal: ' + ((document.documentElement.lang || 'nl').slice(0, 2)));
      return lines.join('\n');
    }

    function updateNav() {
      qsa(root, '[data-back]').forEach(function (b) { b.hidden = state.step <= 1; });
      qsa(root, '[data-next]').forEach(function (b) { b.hidden = state.step >= 3; });
      qsa(root, '[data-to-result]').forEach(function (b) { b.hidden = state.step !== 3; });
      qsa(root, '[data-submit]').forEach(function (b) { b.hidden = state.step !== 4; });
    }

    qsa(root, '[data-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!validateStep(state.step)) return;
        if (state.step === 1) showStep(2);
        else if (state.step === 2) showStep(3);
      });
    });
    qsa(root, '[data-to-result]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!validateStep(3)) return;
        var data = collectEngineInput();
        var est = runEstimate(data);
        state.estimate = est;
        if (!state.ref) state.ref = makeRef();
        renderResult(est);
        showStep(4);
      });
    });
    qsa(root, '[data-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (state.step > 1) showStep(state.step - 1);
      });
    });

    var kw = form.elements.namedItem('power_kw');
    var pk = form.elements.namedItem('power_pk');
    if (kw) kw.addEventListener('input', function () {
      var v = parseFloat(kw.value);
      if (!isNaN(v) && pk) pk.value = Math.round(v * 1.35962);
    });
    if (pk) pk.addEventListener('input', function () {
      var v = parseFloat(pk.value);
      if (!isNaN(v) && kw) kw.value = Math.round(v / 1.35962);
    });

    if (form) {
      form.addEventListener('submit', function (ev) {
        if (state.step !== 4) { ev.preventDefault(); return; }
        var data = collectEngineInput();
        var est = state.estimate || runEstimate(data);
        state.estimate = est;
        var body = form.elements.namedItem('contact[body]');
        if (body) body.value = buildBody(data, est);
        var setH = function (name, val) {
          var el = form.elements.namedItem(name);
          if (el) el.value = val == null ? '' : String(val);
        };
        setH('contact[Merk]', data.make);
        setH('contact[Model]', data.model);
        setH('contact[Bouwjaar]', data.year);
        setH('contact[Km-stand]', data.km);
        setH('contact[Schatting]', est.status === 'ok' ? (est.range[0] + '-' + est.range[1]) : (est.status === 'sport' ? 'persoonlijk (sportversie)' : 'persoonlijk'));
        setH('contact[Sportversie]', est.status === 'sport' ? ('Sportversie: persoonlijk bod (' + est.sport.match + ')') : '');
        setH('contact[Kanaal]', data.channel || 'verkoop');
        if (!state.ref) state.ref = makeRef();
        setH('contact[Referentie]', state.ref);
        setH('contact[Fotos min 4]', ANSWER_NL[data.photos_ok] || data.photos_ok);
        setH('contact[Boorddocumenten]', ANSWER_NL[data.docs_ok] || data.docs_ok);
        if (body) body.value = buildBody(data, est);
        try {
          sessionStorage.setItem('xcs_inkoop_last', JSON.stringify({
            est: est, ref: state.ref, make: data.make, model: data.model, year: data.year, name: data.name, ts: Date.now()
          }));
        } catch (e) {}
      });
    }

    qsa(root, '[data-channel]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var ch = btn.getAttribute('data-channel');
        var el = form.elements.namedItem('channel');
        if (el) el.value = ch;
        qsa(root, '[data-channel]').forEach(function (b) { b.classList.toggle('is-on', b === btn); });
      });
    });

    // Populate make datalist from table
    var makeList = qs(root, '#xit-makes');
    if (makeList && table.models) {
      var makes = {};
      table.models.forEach(function (m) { makes[m.make] = true; });
      Object.keys(makes).sort().forEach(function (mk) {
        var o = document.createElement('option');
        o.value = mk;
        makeList.appendChild(o);
      });
    }
    var modelList = qs(root, '#xit-models');
    var makeInput = form.elements.namedItem('make');
    function refreshModels() {
      if (!modelList || !table.models) return;
      modelList.innerHTML = '';
      var mk = (makeInput && makeInput.value || '').trim().toLowerCase();
      var seen = {};
      table.models.forEach(function (m) {
        if (mk && m.make.toLowerCase() !== mk) return;
        if (seen[m.model]) return;
        seen[m.model] = true;
        var o = document.createElement('option');
        o.value = m.model;
        modelList.appendChild(o);
      });
    }
    if (makeInput) makeInput.addEventListener('change', refreshModels);
    if (makeInput) makeInput.addEventListener('blur', refreshModels);

    function showAfterSubmit(last) {
      if (last && last.est) { state.estimate = last.est; renderResult(last.est); }
      state.ref = (last && last.ref) || state.ref || makeRef();
      showStep(4, true);
      var vars = { ref: state.ref, make: (last && last.make) || '', model: (last && last.model) || '', year: (last && last.year) || '', name: (last && last.name) || '' };
      var refOut = qs(root, '[data-ref-out]');
      if (refOut) refOut.textContent = state.ref;
      var wa = qs(root, '[data-wa-link]');
      var nr = (root.getAttribute('data-wa') || '32470566121').replace(/[^0-9]/g, '');
      if (wa) wa.href = 'https://wa.me/' + nr + '?text=' + encodeURIComponent(fill(t('wa_text', "Hallo XCS, hierbij de foto's voor inkoopaanvraag {ref}: {make} {model}, bouwjaar {year}."), vars));
      var ml = qs(root, '[data-mail-link]');
      if (ml) ml.href = 'mailto:info@xcsautomotive.be?subject=' + encodeURIComponent(fill(t('mail_subject', "Foto's inkoop {ref}"), vars)) +
        '&body=' + encodeURIComponent(fill(t('mail_body', "Hallo XCS,\n\nIn bijlage de foto's voor inkoopaanvraag {ref}.\nWagen: {make} {model}, bouwjaar {year}\nNaam: {name}\n\nMinstens 4 buitenfoto's en een foto van het kentekenbewijs of VIN.\n\nMet vriendelijke groeten"), vars));
      var after = qs(root, '[data-after-submit]');
      var panel4 = qs(root, '[data-step="4"]');
      if (after && panel4) { panel4.insertBefore(after, panel4.firstChild); after.style.marginTop = '0'; after.style.marginBottom = '2rem'; }
      if (after) after.hidden = false;
      var choice = qs(root, '[data-step="4"] .xit-choice');
      if (choice) choice.hidden = true;
      qsa(root, '[data-before-submit]').forEach(function (el) { el.hidden = true; });
      qsa(root, '[data-step="4"] [data-back], [data-submit]').forEach(function (b) { b.hidden = true; });
      var nav = qs(root, '[data-step="4"] .xit-nav');
      if (nav) nav.hidden = true;
    }

    var lastSub = null;
    try { lastSub = JSON.parse(sessionStorage.getItem('xcs_inkoop_last') || 'null'); } catch (e) {}
    var urlPosted = /[?&]contact_posted=true/.test(window.location.search);
    var fresh = lastSub && lastSub.ts && (Date.now() - lastSub.ts) < 2 * 3600 * 1000;
    if (root.getAttribute('data-posted') === '1' || (urlPosted && fresh)) {
      showAfterSubmit(lastSub);
    } else {
      showStep(1, true);
    }

    root._xcsInkoop = { engine: engine, table: table, collect: collectEngineInput, run: runEstimate, detectSport: function (d) { return detectSport(table, d); }, estimate: function (d, ref) { return estimateWithSport(getEngine() || engine, table, d, ref); } };
  }

  function boot() { qsa(document, '[data-xcs-inkoop]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
